import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../tickets.css';

const TicketCard = ({ ticket, isAdmin, onDelete }) => {
  const navigate = useNavigate();

  const handleViewClick = (e) => {
    e.stopPropagation();
    navigate(`/user-dashboard/tickets/${ticket.id}`);
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    onDelete(ticket.id);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins} min${diffMins > 1 ? 's' : ''} ago`;
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;

    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
    });
  };

  const canDelete = () => {
    if (isAdmin) return true;
    return ticket.status === 'OPEN';
  };

  return (
    <div className="ticket-card-container" onClick={handleViewClick}>
      <div className="ticket-card-header">
        <div className="ticket-id">Ticket No: {ticket.id}</div>
        <div className="ticket-badges">
          <span className="ticket-status" data-status={ticket.status}>
            {ticket.status === 'IN_PROGRESS' ? 'In Progress' : ticket.status}
          </span>
          <span className="ticket-priority" data-priority={ticket.priority}>
            {ticket.priority}
          </span>
        </div>
      </div>

      <div className="ticket-card-body">
        <h3 className="ticket-title">{ticket.title}</h3>
        <p className="ticket-description">{ticket.description}</p>

        <div className="ticket-meta">
          <div className="ticket-meta-row">
            <span className="ticket-created">{formatDate(ticket.created_at)}</span>
            {ticket.issue_type && (
              <span className="ticket-issue-type">
                {ticket.issue_type === 'GENERAL_QUESTION' ? 'Question' :
                 ticket.issue_type === 'FEATURE_REQUEST' ? 'Feature' :
                 ticket.issue_type.charAt(0) + ticket.issue_type.slice(1).toLowerCase()}
              </span>
            )}
          </div>

          {ticket.assigned_to && (
            <div className="ticket-meta-row">
              <span className="ticket-assigned">
                Assigned to: <strong>{ticket.assigned_to_username || 'Admin'}</strong>
              </span>
            </div>
          )}

          {ticket.comment_count !== undefined && (
            <div className="ticket-meta-row">
              <span className="ticket-created">
                {ticket.comment_count} comment{ticket.comment_count !== 1 ? 's' : ''}
              </span>
              {ticket.attachment_count !== undefined && (
                <span className="ticket-created">
                  {ticket.attachment_count} attachment{ticket.attachment_count !== 1 ? 's' : ''}
                </span>
              )}
            </div>
          )}
        </div>

        <div className="ticket-footer">
          <div className="ticket-actions">
            <button className="btn-view" onClick={handleViewClick}>
              View
            </button>
            {canDelete() && (
              <button className="btn-delete" onClick={handleDeleteClick}>
                Delete
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketCard;
